import { gql, TypedDocumentNode } from "@apollo/client";

import {
  Context,
  QuerySearchSpaceContextsArgs,
  QuerySearchSpaceContextsSuggestionsArgs,
  SearchSpaceContextsOutput,
  SearchSuggestionsOutput,
  Space,
  SpaceContextConnection,
} from "types/generated";

type SpaceDetailsContextNode = Pick<Context, "id" | "name" | "description"> & {
  spaceDetails: Pick<Space, "id" | "name">;
};

type SpaceDetailsContextEdge = Pick<SpaceContextConnection, "cursor" | "inherited"> & {
  node: SpaceDetailsContextNode;
};

type SearchSpaceContextsData = {
  searchSpaceContexts: {
    edges: Array<SpaceDetailsContextEdge>;
    pageInfo: SearchSpaceContextsOutput["pageInfo"];
  };
};

export const SEARCH_SPACE_CONTEXTS: TypedDocumentNode<
  SearchSpaceContextsData,
  QuerySearchSpaceContextsArgs
> = gql`
  query SearchSpaceContexts($space: ID!, $input: SearchInput!) {
    searchSpaceContexts(space: $space, input: $input) {
      edges {
        cursor
        inherited
        node {
          id
          name
          description
          spaceDetails {
            id
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

type SearchSpaceContextsCountData = {
  searchSpaceContextsSuggestions: {
    filteredCount: SearchSuggestionsOutput["filteredCount"];
  };
};

export const SEARCH_SPACE_CONTEXTS_COUNT: TypedDocumentNode<
  SearchSpaceContextsCountData,
  QuerySearchSpaceContextsSuggestionsArgs
> = gql`
  query SearchSpaceContextsCount($space: ID!, $input: SearchSuggestionsInput!) {
    searchSpaceContextsSuggestions(space: $space, input: $input) {
      filteredCount
    }
  }
`;
